import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config/api';
import siteContentStatic from '../data/siteContent.json';

function NotreHistoire() {
  const [data, setData] = useState(siteContentStatic.history);

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(content => { if (content.history) setData(content.history); })
      .catch(() => {});
  }, []);

  return (
    <article className="post-8 page type-page status-publish hentry">
      <header className="entry-header">
        <h1 className="entry-title">{data.title}</h1>
      </header>

      <div className="entry-content">
        {data.paragraphs.slice(0, 5).map((p, i) => (
          <p key={i} style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: p }} />
        ))}

        {data.mainImage && (
          <div className="page-image-showcase">
            <img
              src={data.mainImage}
              alt="accueil de jour pour femmes SDF et enfants 78 Versailles"
              loading="lazy"
            />
          </div>
        )}

        {data.paragraphs.slice(5).map((p, i) => (
          <p key={`after-${i}`} style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: p }} />
        ))}

        {data.galleryImages && data.galleryImages.length > 0 && (
          <div className="wp-block-gallery columns-default">
            {data.galleryImages.map((img, i) => (
              <figure key={i} className="wp-block-image size-large">
                <img
                  loading="lazy"
                  src={img.src}
                  alt={img.alt}
                />
              </figure>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default NotreHistoire;
